<mat-dialog-content>
  <h1>{{ 'Turbo.Messages.SendMessageDialog.Headline' | translate : 'Send Message' }}</h1>

  <div style="width: 600px;">
    <div class="turboContainer">
      <mat-tab-group>
        <mat-tab label="{{ 'Turbo.Messages.SendMessageDialog.tabReceivers' | translate : 'Receivers' }}">
          <div class="col-xs-12">
            <mat-form-field class="example-chip-list" *ngIf="Settings.isInAny(['OneWayAdmin', 'Admin'])">
              <mat-chip-grid #chipList style="max-height: 100px; overflow-y: auto;">
                <mat-chip-row *ngFor="let receiver of selectedReceivers"
                          selectable="false"
                          removable="true"
                          (removed)="removeReceiver(receiver)">
                  {{receiver.FriendlyName}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
                <input placeholder="{{ 'Turbo.Messages.SendMessageDialog.lblReceivers' | translate : 'Receivers' }}"
                       #receiverInput
                       [formControl]="txtReceivers"
                       [matAutocomplete]="auto"
                       [matChipInputFor]="chipList"
                       matChipInputAddOnBlur="false"
                       (matChipInputTokenEnd)="addReceiver($event)">
              </mat-chip-grid>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectReceiver($event)">
                  <mat-option *ngFor="let receiver of filteredReceivers | async" [value]="receiver" matTooltip="{{receiver.Description}}">
                    {{receiver.FriendlyName}}
                  </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-radio-group [(ngModel)]="tmpReceiver" *ngIf="!Settings.isInAny(['OneWayAdmin', 'Admin'])">
              <mat-radio-button value="Brenderup" style="margin-right: 15px;">Brenderup</mat-radio-button>
              <mat-radio-button value="OneWay" *ngIf="Settings.clientSettings.IsOneWay">OneWay</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'Turbo.Messages.SendMessageDialog.lblSettings' | translate : 'Settings' }}" *ngIf="Settings.isInAny(['Admin', 'OneWayAdmin'])">
          <div class="col-xs-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblPriority' | translate : 'Priority' }}</mat-label>
              <mat-select placeholder="" [(ngModel)]="priority">
                <mat-option *ngFor="let prio of priorities" [value]="prio">
                  {{'Turbo.Messaging.MessagePriority.' + prio  | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblLanguage' | translate : 'Language' }}</mat-label>
              <mat-select placeholder="" [(ngModel)]="language">
                <mat-option *ngFor="let l of languages" [value]="l">
                  {{ l }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblValidFrom' | translate : 'Valid from' }}</mat-label>
              <input placeholder="" matInput [matDatepicker]="startPicker" [(ngModel)]="validFrom">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblValidThrough' | translate : 'Valid through' }}</mat-label>
              <input placeholder="" matInput [matDatepicker]="endPicker" [(ngModel)]="validThrough">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <mat-checkbox [(ngModel)]="requireReadConfirmation">{{ 'Turbo.Messages.SendMessageDialog.chkRequireReadConfirmation' | translate : 'Require read confirmation' }}</mat-checkbox>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <h2>Message</h2>
    <div class="turboContainer">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblSubject' | translate : 'Subject' }}</mat-label>
        <input placeholder="" matInput [(ngModel)]="subject">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Turbo.Messages.SendMessageDialog.lblContent' | translate : 'Content'}}</mat-label>
        <textarea matInput matTextareaAutosize matAutosizeMinRows="15" [(ngModel)]="content" cdkTextareaAutosize></textarea>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="send()">{{'Turbo.Messages.SendMessageDailog.cmdSend' | translate : 'Send'}}</button>
</mat-dialog-actions>

